"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ClarityInCare() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="clarity-in-care" className="relative w-full min-h-[800px] flex items-center overflow-hidden bg-[radial-gradient(circle_at_80%_50%,_var(--color-accent)_0%,_var(--color-background)_60%)]">
      <div className="container mx-auto px-6 py-20 lg:py-0 h-full">
        <div className="flex flex-col lg:flex-row items-center h-full gap-12 lg:gap-0">
          
          {/* Left: Text Content */}
          <div ref={ref} className={`w-full lg:w-[60%] flex flex-col justify-center z-10 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <h1 className="font-serif text-6xl md:text-7xl lg:text-8xl font-medium tracking-tighter text-foreground leading-[0.9] mb-8">
              Clarity in <br />
              <span className="italic text-primary/80">Dental Care</span>
            </h1>
            
            <p className="font-sans text-lg md:text-xl text-muted-foreground max-w-xl leading-relaxed mb-10">
              OralGuide simplifies dental health with high-quality, evidence-based guides. 
              We provide a calm, authoritative resource for understanding your oral hygiene 
              without the noise of clinical affiliations.
            </p>

            <div className="flex flex-wrap gap-4">
              <Button asChild size="lg" className="rounded-full px-8 h-14 text-lg bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg hover:shadow-xl transition-all duration-300">
                <Link to="/KnowledgeHubPage">
                  Start Learning
                  <ArrowRight className="ml-2 w-5 h-5" />
                </Link>
              </Button>
            </div>
          </div>

          {/* Right: Visual Element - Replaced 3D with gradient background */}
          <div className="w-full lg:w-[40%] h-[500px] lg:h-[800px] relative z-0">
            <div className="absolute inset-0 w-full h-full bg-gradient-to-br from-primary/20 via-accent/30 to-primary/10 rounded-3xl backdrop-blur-sm">
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-primary/10 rounded-full blur-3xl animate-pulse"></div>
              <div className="absolute top-1/3 left-1/3 w-48 h-48 bg-accent/20 rounded-full blur-2xl animate-pulse delay-700"></div>
            </div>
          </div>
          
        </div>
      </div>
    </section>;
}